export interface Project {
    id: number;
    name: string;
}

export function ProjectFromJSON(json: any): Project {
    return {
        id: json["id"],
        name: json["name"],
    }
}
